export default __webpack_public_path__ + "static/sm-poster6-f2bb27443885f242eeacc8bd5225f70a.png";